// @flow
import { ticketingCcModalActions } from "./ticketingCcModalActionCreator";

const initialState = {
  emailCcOptionsDetails: {
    isLoading: false,
    isLoaded: false,
    data: []
  }
};

const ticketingCcModalReducer = (
  state: Object = initialState,
  action: Object
) => {
  switch (action.type) {
    case ticketingCcModalActions.GET_EMAIL_CC_OPTIONS: {
      return Object.assign({}, state, {
        emailCcOptionsDetails: action.payload
      });
    }
    default: {
      return state;
    }
  }
};

export default ticketingCcModalReducer;



// WEBPACK FOOTER //
// ./app/components/commons/ticketingCcModal/ticketingCcModalRedux/ticketingCcModalReducer.js